/** Специальные виджеты  (Визуальные компоненты) для отображения элементов (полей в карточке) АДМС каталога 
 * Параметрами является:
 * 1. uri - отображаемое свойства (predicate);
 * 2. lang - текущий язык
 * 3. values
*/
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { InfoOutlined } from '@ant-design/icons';
import { BaseViewLiteralComponent } from '../widgets/ViewLiteral';
import { ViewHTMLComponent } from '../widgets/ViewHTML';
import { SimpleViewLinkComponent } from '../widgets/ViewLink';
import { sortConceptSchemesTaxonomy } from '../skos/helper';

/** Формирование ссылки в зависимоти от наличия базового пути в маршруте  */
const makeLink = (item, getBaseRoutePath=undefined) => {
  return getBaseRoutePath 
    ? '#'+getBaseRoutePath(`subject/${encodeURIComponent(item?.object?.value || item?.IRI || item?.subject || "")}`)
    : `#/subject/${encodeURIComponent(item?.object?.value || item?.IRI || item?.subject || "")}`;
}
//
//Визуальные компоненты для отображения полей в карточке adms каталога
//

/** Отображение значения по умолчанию. Получается список всех доступных значения, фильтруется по языку. */
export const DefaultValue = ({uri, lang, values}) => {
  //console.log("DefaultValue", uri, lang, values);
  return (
    <BaseViewLiteralComponent uri={uri} lang={lang} values={values}/>
  )
}

/** Отображение значений описания. Получается список всех доступных значения, фильтруется по языку. */
export const DescriptionValue = ({uri, lang, values}) => {
  //console.log("DescriptionValue", uri, lang, values);
  return (
    <ViewHTMLComponent uri={uri} lang={lang} values={values}/>
  )
}


//Значения классификационных схем
export const Concepts = ({uri, lang, values, factory, action, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const concepts = factory.provider.subsetByLangOrEmpty(subset, lang);
  const isDetail = action!=undefined;
  return (
    <span>
      {concepts.map((item, i) => 
        <div key={i} className="csi_icon_div csi_concept_div" resource={item.object.value} style={{"width":"100%"}}>
          <a
            href={makeLink(item,getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          ><SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a>
          
          {/* {isDetail?
            <Button icon={<InfoOutlined style={{ padding: "0 0 0 0.5rem"}} />} shape="circle" size="small" onClick={(e)=>action(e, "detail", item)} />
            :
              <span>{item.object.value}</span>
          }  */}
          <br/>  
        </div>
      )}
    </span>
  )
}

//Значения классификационных схем
export const Concept = ({uri, lang, values, factory, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const concepts = factory.provider.subsetByLangOrEmpty(subset, lang);  
  return (
    <span>
      {concepts.map((item, i) => 
        <span key={i}>
          <a
            href={makeLink(item, getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a>
        <br/>
        </span>
      )}
    </span>
  )
}

// Список классификационных схем.  
// Аналогичная сортировка используется в sortTaxonomy из AdmsActions.js 
export const ConceptSchemes = ({uri, lang, values, factory, getBaseRoutePath=undefined}) => {
  //console.log("AssetWidgets.js ConceptSchemes", uri, lang, values, factory);
  const schemes = sortConceptSchemesTaxonomy(values, factory.provider, uri, lang);
  return (
    <span>
      {schemes.map((item, i) => 
        <span key={i}>
          <a
            href={makeLink(item,getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a>
        <br/>
        </span>
      )}
    </span>
  )
}

//Информация об агентах (издатель, публикатор и т.п. foaf:Agent)
export const Foaf = ({uri, lang, values, factory, action, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const agens = factory.provider.subsetByLangOrEmpty(subset, lang);
  const isDetail = action!=undefined;
  return (
    <span>
      {agens.map((agent, i) => 
        <div key={i} className="csi_icon_div csi_publisher_div" resource={agent.object.value}>
          <a
            href={makeLink(agent, getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={agent.object.value} factory={factory}  triplet={agent} lang={lang}/>
          </a>
            {/* {isDetail?
                <Button icon={<InfoOutlined style={{ padding: "0 0 0 0.5rem"}} />} shape="circle" size="small" onClick={(e)=>action(e, "detail", agent)} />
              :
                <span>{agent.object.value}</span>
            }    */}
        </div>
      )}
    </span>        
  )
}

//Информация об частях 
export const HasUnit = ({uri, lang, values, factory, action, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const units = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {units.map((unit, i) => 
        <div key={i} className="csi_icon_div csi_publisher_div" resource={unit.object.value} style={{"display": "block"}}>
          <a
            href={makeLink(unit,getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={unit.object.value} factory={factory}  triplet={unit} lang={lang}/>
          </a>
        </div>
      )}
    </span>        
  )
}

const ComponentVCard = ({vcard}) => <span>{vcard.object.value}</span>;
const ComponentVCardLink = ({vcard, action=f=>f}) => 
  <Button icon={<InfoOutlined style={{ padding: "0 0 0 0.5rem"}} />} shape="circle" size="small" onClick={(e)=>action(e, "detail", vcard)} />
//Информация об контактных данных (vCard)
export const vCard = ({uri, lang, values, factory, action, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const vcards = factory.provider.subsetByLangOrEmpty(subset, lang);
  const Component = (action)?ComponentVCardLink:ComponentVCard;
  return (
    <span>
      {vcards.map((vcard, i) => 
        <div key={i} className="csi_icon_div csi_copy_div" resource={vcard.object.value}>
          <a
            href={makeLink(vcard, getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={vcard.object.value} factory={factory}  triplet={vcard} lang={lang}/>
          </a>
          {/* <Component vcard={vcard} action={action}/> */}
        </div>
      )}
    </span>        
  )
}

//Информация о поддерживаемых языках
export const Language = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const langs = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {langs.map((item, i) => 
        <div key={i} className="csi_icon_div csi_language_div" resource={item.object.value}>
          <a
            href={`#/subject/${encodeURIComponent(item?.object?.value || item?.IRI || item?.subject || "")}`}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a>
        </div>
      )}
    </span>        
  )
}

//Внешние (активные линки)
export const ExternalLink = ({uri, lang, values, factory, history}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {links.map((item, i) => 
        <p key={i}>
          {item.object.value.startsWith("/viewemd/")?
              <Link to={item.object.value}>{item.object.value}</Link>
            :
            <a href={item.object.value} target="_blank">{item.object.value}</a>
          }          
        </p>
      )}
    </span>        
  )
}

/**
 * Внешняя сслыка или HTML текст
 */
export const ExternalLinkOrHTML = ({uri, lang, values, factory, history}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
  //console.log("AssetWidgets.js ExternalLinkOrHTML", links)
  return (
    <span>
      {links.map((item, i) => 
        <p key={i}>
          {item.object.value.startsWith("http://") || item.object.value.startsWith("https://")?
             <a href={item.object.value} target="_blank">{item.object.value}</a>
            :
            <ViewHTMLComponent uri={uri} lang={lang} values={[item]}/>
          }          
        </p>
      )}
    </span>        
  )
}

/** 
 * Идентификатор http://purl.org/dc/terms/identifier
 * 
 * Рекомендуемая практика — идентифицировать ресурс с помощью строки, соответствующей системе идентификации. 
 * Примерами служат Международный стандартный номер книги (ISBN), Цифровой идентификатор объекта (DOI) 
 * и Единое имя ресурса (URN). Постоянные идентификаторы должны быть предоставлены как HTTP URI.
*/
export const DCTermsIdentifierLink = ({uri, lang, values, factory, history}) => {
  //console.log("AssetWidgets.js DCTermsIdentifierLink", uri, lang, values);
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
  //console.log("AssetWidgets.js DCTermsIdentifierLink", subset, links);
  return (
    <span>
      {links.map((item, i) => 
        <p key={i}>
          {item.object.value.startsWith("http://") || item.object.value.startsWith("https://")?
            <a href={item.object.value} target="_blank">{item.object.value}</a>
            :
            <span>{item.object.value}</span>
          }          
        </p>
      )}
    </span>        
  )
}

//Информация о лицензии
export const License = ({uri, lang, values, factory, action, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const langs = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {langs.map((item, i) => 
        <div key={i} className="csi_icon_div csi_language_div" resource={item.object.value}>
          <a
            href={makeLink(item, getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a>
            {/* <Button icon={<InfoOutlined style={{ padding: "0 0 0 0.5rem"}} />} shape="circle" size="small" onClick={(e)=>action(e, "detail", item)}/> */}
        </div>
      )}
    </span>        
  )
}

//Скачивание файлов
export const FileDownload  = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
    return (
    <span>
      {links.map((link, i) => 
          <a key={i} href={link.object.value} target="_blank">{link.object.value}</a>
      )}
    </span>        
  )
}

export const AssetLink = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const links = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {links.map((asset, i) => 
        <p key={i}>
          <Link to={"/adms/"+encodeURIComponent(asset.object.value)} target="_blank" resource={asset.object.value}>
            <SimpleViewLinkComponent IRI={asset.object.value} factory={factory}  triplet={asset} lang={lang}/>
          </Link>
        </p>
      )}
    </span>        
  )
}

export const AssetLink2 = ({field, value}) => {
    return (
<div className="csi_value_div">
    {value.map((asset, i) => <Link to={"/emd/"+asset.NodId} key={i}>{asset.NName}<br/></Link>)}
</div>        
    )
}

/** Отображение значения по умолчанию. Получается список всех доступных значения, фильтруется по языку. */
export const KeywordValue = ({uri, lang, values, factory}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const words = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {words.map((word, i) => 
      <span>
        {i > 0 ? ", ":""} <BaseViewLiteralComponent uri={uri} lang={lang} values={[word]}/>
      </span>
      )}
    </span>
  )
}

//Информация об использовании в ConceptScheme
export const InScheme = ({uri, lang, values, factory, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const langs = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {langs.map((item, i) => 
        <div key={i} className="csi_icon_div csi_inscheme_div" resource={item.object.value}>
          <a
            href={makeLink(item, getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a>
        </div>
      )}
    </span>        
  )
}

//Информация об использовании концепта
export const LinkConcept = ({uri, lang, values, factory, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const langs = factory.provider.subsetByLangOrEmpty(subset, lang);
  return (
    <span>
      {langs.map((item, i) => 
        <div key={i} className="csi_icon_div csi_linkconcelt_div" resource={item.object.value}>
          <a
            href={makeLink(item, getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a>            
        </div>
      )}
    </span>        
  )
}

export const LinkSimple = ({uri, lang, values, factory, getBaseRoutePath=undefined}) => {
  const subset = (values && Array.isArray(values))? factory.provider.subsetValuesByURI(values, uri):[];
  const langs = factory.provider.subsetByLangOrEmpty(subset, lang);  
  console.log("AssetWidgets.js", LinkSimple, langs);
  return (
    <span>
      {langs.map((item, i) => 
        <div key={i} className="csi_icon_div csi_linkconcelt_div" resource={item.object.value}>
          {item.object.type === "uri" && !item.object.value.startsWith("_:") && !item.object.value.startsWith("nodeID://") ? <a
            href={makeLink(item, getBaseRoutePath)}
            target="_blank"
            rel="noopener noreferrer"
            title="Детальная информация"
          >
            <SimpleViewLinkComponent IRI={item.object.value} factory={factory}  triplet={item} lang={lang}/>
          </a> : item.object.value}
        </div>
      )}
    </span>        
  )
}
